const HAS_EVERYTHING = {
  has() {
    return true
  },
}

export const FACILITY_TYPE_ALLOWED_ANNOTATION_TYPES = {
  GO: new Set(['note', 'lightSchedule', 'reading', 'targetRange', 'notification']),
  DEFAULT: HAS_EVERYTHING,
}

export const ALLOWED_FACILITY_TYPE_JOURNAL_TABS = {
  GO: new Set(['everything', 'notes', 'alerts']),
  DEFAULT: HAS_EVERYTHING,
}

export const HISTORICAL_LIMITED_DATA_DAYS = {
  GO: 60,
  DEFAULT: 0,
}
